export default "__VITE_ASSET__CApkjCvA__"